module.exports = __webpack_public_path__ + "static/18-dfdf14d9d9038a48149c9647ad548f06.jpg";